import posthog from "posthog-js";

declare global {
  interface Window {
    posthogSettings?:
      | undefined
      | {
          api_key: string;
          api_host: string;
          user_id: string | undefined;
          groups: Record<string, string> | undefined;
        };
  }
}

export const init = (): void => {
  if (typeof window.posthogSettings !== "object") return;

  posthog.init(window.posthogSettings.api_key, {
    api_host: window.posthogSettings.api_host,
    capture_pageview: "history_change",
    person_profiles: "identified_only",
    session_recording: {
      maskTextSelector: ".sensitive",
    },
  });

  if (window.posthogSettings.user_id) {
    posthog.identify(window.posthogSettings.user_id);
  }

  for (const [groupKey, groupValue] of Object.entries(
    window.posthogSettings.groups || {},
  )) {
    posthog.group(groupKey, groupValue);
  }
};
